import * as XLSX from "xlsx";

/**
 * Converte todas as abas do .xlsx/.xls para texto (CSV por aba),
 * com separador de colunas por TAB para facilitar a leitura pela IA.
 */
export async function extractXlsxTextBrowser(file: File): Promise<string> {
  const buf = await file.arrayBuffer();
  const wb = XLSX.read(buf, { type: "array", codepage: 65001 }); // UTF-8 para preservar acentos

  let out = "";
  for (const sheetName of wb.SheetNames) {
    const ws = wb.Sheets[sheetName];
    if (!ws) continue;
    const csv = XLSX.utils.sheet_to_csv(ws, { FS: "\t" }); // TAB
    if (csv.trim()) {
      out += `# ${sheetName}\n${csv}\n\n`;
    }
  }
  return out.trim();
}
